<template>
  <div class="change-of-state-dialog">
    <gs-modal v-model="visible" :before-close="beforeClose" :before-confirm="beforeConfirm"
      :title="isEdit ? name + '-报警定义' : '新建' + '-报警定义'" :has-form="true" class="change-of-state-dialog-modal"
      @close="close" @cancel="close" @confirm="handleConfirm">
      <gs-tabs v-model="activeName" type="content-tab">
        <gs-tab-pane label="常规" name="General">
          <div class="general-form">
            <gs-form label-width="80px" label-position="left" gap="small">
              <gs-form-item label="名称" prop="name">
                <gs-input ref="nameInput" v-model="name" />
              </gs-form-item>

              <gs-form-item label="报警文本" prop="Description">
                <gs-input v-model="description" />
              </gs-form-item>
              <!-- <gs-form-item label="状态报警" prop="objectProperty" style="margin-top: 10px;">
                <div class="limit" style="width: 100%;">
                  <div style="margin-top: 1px;">
                    <el-radio v-model="form.ruleStatus" label="2" @change='ruleStatusChange'>&nbsp;</el-radio>
                  </div>
                  <gs-select size="mini" v-model="form.on_off" class="doc-select" style="width: 100%;height: 20px;">
                    <gs-option v-for="item in referencedOptions" :key="item.value" :label="item.label"
                      :value="item.value" />
                  </gs-select>

                </div>
              </gs-form-item> -->
              <!--  <gs-form-item label="阈值报警" prop="objectProperty" style="margin-top: 10px;">
                <div class="limit" style="width: 100%;">
                  <div style="margin-top: 1px;">
                    <el-radio v-model="form.ruleStatus" @change='ruleStatusChange' label="1">&nbsp;</el-radio>
                  </div>
                  <gs-form-item label="" prop="low">
                    <el-input v-model="form.low" placeholder="最低值" size="mini" />
                  </gs-form-item>
                  <gs-form-item label="" prop="high" style="margin-left: 10px;">
                    <el-input v-model="form.high" placeholder="最高值" size="mini" />
                  </gs-form-item>
                </div>
              </gs-form-item> -->
            </gs-form>
          </div>
        </gs-tab-pane>
        <gs-tab-pane label="监控对象" name="Object">
          <div class="object-form">
            <gs-form label-width="100px" label-position="left" gap="small">
              <gs-form-item label="选择监控对象" prop="monitorObject">
                <gs-input v-model="showObject" style="width:50%;margin-left: 30px;" />
                <gs-button size="mini" @click="addObject">...</gs-button>
              </gs-form-item>
              <gs-form-item label="状态报警" prop="objectProperty" style="margin-top: 10px;">
                <div class="limit">
                  <div style="margin-top: 1px;">
                    <el-radio v-model="form.ruleStatus" label="2" @change='ruleStatusChange'>&nbsp;</el-radio>
                  </div>
                  <gs-select size="mini" v-model="form.on_off" class="doc-select">
                    <gs-option v-for="item in referencedOptions" :key="item.value" :label="item.label"
                      :value="item.value" />
                  </gs-select>

                </div>
              </gs-form-item>
              <gs-form-item label="阈值报警" prop="objectProperty" style="margin-top: 10px;">
                <div class="limit" style="width: 78.5%;">
                  <div style="margin-top: 1px;">
                    <el-radio v-model="form.ruleStatus" @change='ruleStatusChange' label="1">&nbsp;</el-radio>
                  </div>
                  <gs-form-item label="" prop="low">
                    <gs-input v-model="form.low" placeholder="最低值" size="mini" />
                  </gs-form-item>
                  <gs-form-item label="" prop="high" style="margin-left: 10px;">
                    <gs-input v-model="form.high" placeholder="最高值" size="mini" />
                  </gs-form-item>
                </div>
              </gs-form-item>
            </gs-form>
          </div>
        </gs-tab-pane>
      </gs-tabs>
      <span slot="footer" class="dialog-footer">
        <gs-button type="primary" size="mini" @click="handleConfirm">确 定</gs-button>
        <gs-button type="primary" size="mini" @click="beforeClose">取 消</gs-button>
        <gs-button type="primary" size="mini" @click="dialogHelp = true">帮 助</gs-button>
      </span>
    </gs-modal>
    <gs-modal v-model="visibleAlarmControl" :before-close="beforeCloseAlarmControl" class="alarmControl-select"
      title="添加报警控制对象" @close="closeAlarmControl" @confirm="handleConfirmAlarmControl">
      <div class="dataList">
        <gs-tree v-if="visibleAlarmControl" ref="tree" :data="dataList" :props="props" :disable-node="true"
          :leaf-checkbox-only="true" :node-key="'id'" show-checkbox @check-change="checkEvent" />
      </div>
    </gs-modal>
    <gs-modal v-model="visibleObject" :before-close="beforeCloseObject" class="alarmControl-select" title="添加监控对象"
      @close="closeObject" @confirm="handleConfirmObject">
      <div class="dataList">
        <gs-tree v-if="visibleObject" ref="tree" :data="dataList" :props="props" :disable-node="true"
          :leaf-checkbox-only="true" :node-key="'id'" show-checkbox @check-change="checkEvent" />
      </div>
    </gs-modal>
    <gs-modal title="帮助-状态变化" v-model="dialogHelp" class="my-test-class" width="50%" :before-close="handleCloseHelp">
      <span class="tab">常规</span><br>
      <hr />
      <span class="tit">名称：</span><span class="txt">状态变化-系统对象的名字</span><br>
      <span class="tit">描述：</span><span class="txt">对该状态变化-系统对象的介绍描述</span><br>
      <span class="tit">禁用设置：</span><span class="txt">禁用设置状态分为不禁用和手动禁用两种状态</span><br>
      <span class="tab">报警</span><br>
      <hr />
      <span class="tit">报警控制图形：</span><span class="txt">在发生报警后弹出指定的图形化界面</span><br>
      <span class="tab">监控对象</span><br>
      <hr />
      <span class="tit">选择监控对象：</span><span class="txt">监控该对象的值是否发生报警</span><br>
      <span class="tit">引用属性：</span><span class="txt">值</span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <!--<el-button @click="dialogHelp = false">取 消</el-button>
      <el-button type="primary" @click="dialogHelp = false">确 定</el-button>-->
    </gs-modal>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
export default {
  data() {
    return {
      selectId: '',
      ruleShow: false,
      radio: '0',
      dialogHelp: false,
      isEdit: false,
      visibleAlarmControl: false,
      visibleObject: false,
      activeName: 'General',
      name: '',
      description: '',
      dataList: [],
      props: {
        label: 'name',
        disabled: 'type:folder'
      },
      form: {
        status: '',
        disabled: '',
        alarmControl: null,
        tripped_text: '',
        reset_text: '',
        trigging_text: '',
        resetting_text: '',
        low: '',
        high: '',
        minChange: 0,
        monitorObject: null,
        objectProperty: '',
        time: '',
        number: '',
        ruleStatus: '2',
        on_off: '0',
      },
      referencedOptions: [
        {
          value: '1',
          label: 'on'
        },
        {
          value: '0',
          label: 'off'
        },
      ],
      showAlarmControl: '',
      showObject: ''
    }
  },
  computed: {
    ...mapState({
      visible: 'changeOfStateShow',
      objectData: 'objectInfo',
      nodeData: 'nodeTree'
    })
  },
  watch: {
    'form.alarmControl': function () {
      this.showAlarmControl = this.form.alarmControl ? this.form.alarmControl.fullName : ''
    },
    'form.monitorObject': function () {
      this.showObject = this.form.monitorObject ? this.form.monitorObject.fullName : ''
    },
    showAlarmControl() {
      if (this.form.alarmControl && this.showAlarmControl !== this.form.alarmControl.fullName) {
        this.form.alarmControl = null
      }
    },
    showObject() {
      if (this.form.monitorObject && this.showObject !== this.form.monitorObject.fullName) {
        this.form.monitorObject = null
      }
    },
    tableData() {
      this.form.objList = this.tableData
    },
    visible() {
      if (this.visible) {
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
        if (JSON.stringify(this.objectData) !== '{}' && this.objectData.type === 'stateChange') {
          this.form = this.objectData.attribute ? this.objectData.attribute : {}
          this.description = this.objectData.description ? this.objectData.description : ''
          this.name = this.objectData.name ? this.objectData.name : ''
          this.form.alarmControl = this.form.alarmControl ? this.form.alarmControl : null
          this.form.monitorObject = this.form.monitorObject ? this.form.monitorObject : null
          this.activeName = 'General'
          this.isEdit = true
        } else {
          this.isEdit = false
          this.activeName = 'General'
          this.name = ''
          this.description = ''
          this.form = {
            // status: '',
            // priority: '',
            disabled: 'notDisabled',
            // logical: '',
            // time: null,
            alarmControl: null,
            tripped_text: '',
            reset_text: '',
            trigging_text: '',
            resetting_text: '',
            low: '',
            high: '',
            minChange: 0,
            // textType: '11111111',
            monitorObject: null,
            objectProperty: 'value',
            time: '',
            count: '',
            number: '',
            ruleStatus: '2',
            // linkedGraphic: '',
            // showGraphic: false,
            // linkedReport: '',
            // linkedNotes: '',
            // linkedTrendChart: '',
            // numberOfChanges: 0,
            // lastChange: null,
            // lastReset: null,
            // acStatus: '',
            // timeoutForAcknowledging: null,
            // timeoutForDisabling: null
          }
        }
      }
    }
  },
  mounted() {

  },
  methods: {
    ...mapMutations({
      close: 'CHANGE_OF_STATE_HIDE',
      showSelectDialog: 'SELECT_DIALOG_SHOW',
      needReload: 'NEED_RELOAD_TREE'
    }),
    // 状态变化
    ruleStatusChange() {
      if (this.form.ruleStatus === '2') {
        this.ruleShow = false
      } else {
        this.ruleShow = true
      }
    },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      // done(false)可以阻止modal关闭
      done()
    },
    handleConfirm() {
      // 报警控制只传id
      /* if (this.form.alarmControl != null) {
        this.form.alarmControl = this.form.alarmControl.id
      } */
      // 监控对象只传id
      /* if (this.form.monitorObject != null) {
        this.form.monitorObject = this.form.monitorObject.id
      } */
      this.form.alarmControl = this.selectId
      this.form.monitorObject = this.selectId
      if (this.objectData.id && this.objectData.type === 'stateChange') {
        let param = {
          'id': this.objectData.id,
          'name': this.name,
          'type': this.objectData.type,
          'value': this.objectData.value,
          'parentId': this.objectData.parentId,
          'description': this.description,
          'attribute': this.form
        }
        service.renamePoint(param).then(res => {
          this.$Message.success('修改成功')
          this.ruleShow = false
          this.close()
        }).catch(err => {
          this.$Message.error(err.message)
        })
      } else {
        let param = {
          'name': this.name,
          'type': 'stateChange',
          'parentId': this.objectData.id,
          'description': this.description,
          'attribute': this.form
        }
        service.newAddPoint(param).then(res => {
          this.ruleShow = false
          this.$Message.success('添加成功')
          this.close()
        }).catch(err => {
          this.$Message.error(err.message)
        })
      }
    },
    beforeClose(e, done) {
      this.form.alarmControl = this.$store.state.objectInfo.id
      console.log(this.nodeData)
      console.log(this.$store.state.objectInfo)
      // done(false)可以阻止modal关闭
      this.close()
      this.ruleShow = false
    },
    addAlarmControl() {
      let _this = this
      this.visibleAlarmControl = true
      service.getTree("Point", this.nodeData.id).then(res => {
        if (res[0] !== null) {
          this.dataList = res
        }
        if (this.form.alarmControl !== null) {
          setTimeout(() => {
            _this.$refs.tree.setChecked(this.form.alarmControl.id, true)
          }, 0)
        }
      })
    },
    beforeCloseAlarmControl() {
      this.visibleAlarmControl = false
    },
    closeAlarmControl() {
      this.visibleAlarmControl = false
    },
    handleConfirmAlarmControl() {
      let array = this.$refs.tree.getCheckedNodes(true)
      if (array != null && array.length > 1) {
        this.$Message.warning('最多只能选择一个')
        return
      }
      this.form.alarmControl = array[0].data
      this.visibleAlarmControl = false
    },
    addObject() {
      let _this = this
      this.visibleObject = true
      service.getTree('Point', this.nodeData.id).then(res => {
        if (res[0] !== null) {
          this.dataList = res
        }
        if (this.form.monitorObject !== null) {
          setTimeout(() => {
            _this.$refs.tree.setChecked(this.form.monitorObject.id, true)
          }, 0)
        }
      })
    },
    beforeCloseObject() {
      this.visibleObject = false
    },
    closeObject() {
      this.visibleObject = false
    },
    handleConfirmObject() {
      let _this = this
      let array = this.$refs.tree.getCheckedNodes(true)
      if (array != null && array.length > 1) {
        this.$Message.warning('最多只能选择一个')
        return
      }
      this.form.monitorObject = array[0].data
      this.selectId = array[0].data.id
      this.visibleObject = false
    },
    checkEvent(node, isSelect, halfSelect) {
      // console.log(node)
      // console.log(isSelect)
      // console.log(halfSelect)
      // if (node.type === 'project' || node.type === 'folder' || node.type === 'device' || node.type === 'deviceGroup') {
      //   console.log(node)
      //   this.$Message.error('此节点为目录，无法被选择')
      //   this.$refs.tree.setChecked(node.id, false)
      // }
    },
    handleCloseHelp() {
      this.dialogHelp = false
    }
  }
}
</script>
<style lang="scss">
.change-of-state-dialog {
  &-modal {
    .gs-select {
      width: 70%;
    }

    fieldset {
      padding: 12px;
      border-radius: 5px;
      border: solid 2px #d9d9d9;
    }

    .gs-radio-group {
      line-height: 24px;
    }

    .limit {
      display: flex;
      width: 100%;
    }

    .page-checkbox {
      margin-bottom: 24px;
    }
  }
}

.dataList {
  height: 300px;
  overflow: auto;
  margin-bottom: 12px;
  padding: 12px;
  border: solid 1px #d9d9d9;
  border-radius: 1px;
}

.el-input__inner {
  border: solid 1px #d9d9d9;
}

.tab {
  font-size: 16px;
  font-weight: 800;
}

.tit {
  font-size: 14px;
  font-weight: 800;
  color: #ffffff;
}

.txt {
  font-size: 14px;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/alarm/changOfState.vue